<template>
  <div
    v-if="item.spec"
    class="spec"
    v-bind:class="[
      useType == 1 ? 'outgoing' : '',
      useType == 2 ? 'incoming' : '',
      this.$isPC ? '' : 'sp-spec',
    ]"
  >
    <h3 class="item-name">
      {{ item.name }}
    </h3>
    <div
      class="spec-image"
      v-bind:style="item.imageHeight ? 'height:' + item.imageHeight + 'px' : ''"
    >
      <img v-lazy="item.imagePath" />
    </div>
    <table class="spec-table">
      <tbody>
        <tr v-for="(spec, key) in item.spec" :key="key">
          <th>{{ specDisplayName[key] ? specDisplayName[key] : key }}</th>
          <td>{{ spec }}</td>
        </tr>
      </tbody>
    </table>
    <span v-if="item.comment" style="font-size: 12px; white-space: pre-line;">{{
      item.comment
    }}</span>
  </div>
</template>

<script>
export default {
  props: ['useType', 'item'],
  data() {
    return {
      specDisplayName: {
        signalStrength: `受信電波強度
        表示機能`,
        configDisplay: `各種の設定時、
        設定段階の表示`,
      },
    }
  },
}
</script>

<style scoped>
.spec {
  align-self: flex-start;

  width: 46%;
  margin-bottom: 40px;
}

.sp-spec {
  width: 100%;
}

.spec .item-name {
  font-size: 18px;
  font-weight: bold;
  line-height: 36px;

  padding-left: 10px;

  text-align: left;
}

.spec .spec-image {
  display: flex;

  width: 100%;
  height: 200px;
  margin: 30px auto;
}

.spec .spec-image img {
  display: block;

  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  margin: auto;
}

.spec.outgoing .item-name {
  color: rgb(20, 149, 23);
  border-left: 10px solid rgb(45, 183, 68);
  background-color: rgb(186, 233, 193);
}

.spec.incoming .item-name {
  color: rgb(11, 92, 154);
  border-left: 10px solid rgb(16, 106, 203);
  background-color: rgb(184, 221, 253);
}

.spec .spec-table {
  width: 100%;
  font-size: 12px;

  margin: 0 auto;

  text-align: left;

  overflow-wrap: anywhere;
}

.spec .spec-table tr {
  white-space: pre-line;
}

.spec .spec-table th {
  font-weight: normal;

  width: 30%;
  padding: 6px 10px 6px 10px;
}

.spec.outgoing .spec-table th {
  background-color: rgb(209, 240, 218);
}

.spec.incoming .spec-table th {
  background-color: rgb(210, 231, 253);
}

.spec .spec-table td {
  padding: 6px 10px 6px 10px;
  padding-left: 10px;

  background-color: rgb(244, 244, 246);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/Spec.vue